import VideoListPage from "@/pages/list/components/VideoListPage";
import { tvCategories } from "@/mocks/videos";

export default function TvPage() {
  return (
    <VideoListPage
      type="tv"
      title="电视剧"
      intro="在线观看热门电视剧资源，覆盖国产及海外。剧集持续更新，支持按类型、地区、年份筛选，完结与连载状态一目了然。"
      categories={tvCategories}
    />
  );
}